import { render } from "./ModalArchivosConTipo.vue?vue&type=template&id=0daa5c12"
import script from "./ModalArchivosConTipo.vue?vue&type=script&lang=js"
export * from "./ModalArchivosConTipo.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__